<div class="preview-card">
  <div class="preview-card-header tt_norms500">
    <h1 class="preview-card-header-title">
      {{ group?.fieldGroupName ?? '' | translate }}
    </h1>
  </div>
  <div class="preview-card-body">
    <ng-container
      *ngFor="
        let field of group?.fieldGroup;
        let i = index;
        trackBy: trackByFn
      ">
      <div [style.order]="field?.order" *ngIf="field">
        <ng-container
          *ngTemplateOutlet="
            fieldItemDataValues;
            context: { fieldItemData: field, content: content, index: i }
          ">
        </ng-container>
      </div>
    </ng-container>

    <div
      [style.order]="fieldArray?.order"
      class="d-flex flex-column"
      *ngFor="
        let fieldArray of group?.fieldArray;
        let i = index;
        trackBy: trackByFn
      ">
      <ng-container *ngIf="fieldArray?.arrayItems">
        <ng-container *ngFor="let arrayItem of fieldArray?.arrayItems">
          <ng-container *ngFor="let fieldGroupItem of arrayItem.formGroup">
            <div [style.order]="fieldGroupItem?.order">
              <ng-container
                *ngTemplateOutlet="
                  nestedBlock;
                  context: {
                    fieldGroupNameData: fieldGroupItem
                  }
                ">
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngFor="let fieldGroupItem of arrayItem.fieldGroup">
            <div [style.order]="fieldGroupItem?.order">
              <ng-container
                *ngTemplateOutlet="
                  fieldItemDataValues;
                  context: {
                    fieldItemData: fieldGroupItem,
                    content: content,
                    index: i
                  }
                ">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #content let-modal>
  <div class="modal-body">
    <div class="modal-header-preview">
      <h1 class="tt_norms500">
        <i class="fa fa-file-text"></i>
        {{ selectedAttachment?.fileName ?? '' | translate }}
      </h1>

      <div class="d-flex gap-3 flex-row">
        <ng-container *ngIf="selectedAttachment && (base64Data || currentBlob)">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary download-btn"
            aria-label="Download"
            (click)="handleDownload()">
            <span class="icon-download-01"></span> {{ 'Download' | translate }}
          </button>
        </ng-container>

        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loadingPreview" class="d-flex justify-content-center mt-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- File Content (only shows when loading completes) -->
    <ng-container *ngIf="!loadingPreview">
      <!-- PDF Preview -->
      <ng-container
        *ngIf="
          selectedAttachment?.fileType === 'application/pdf' && base64Data
        ">
        <pdf-viewer
          [src]="base64Data"
          [render-text]="true"
          [original-size]="true"
          style="width: 100%; height: 80vh; margin-top: 15px"></pdf-viewer>
      </ng-container>

      <!-- Image Preview -->
      <ng-container
        *ngIf="selectedAttachment?.fileType !== 'application/pdf' && filePath">
        <img [src]="filePath" alt="preview" class="w-100 h-100 mt-3" />
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- Field Item Data Values Template -->
<ng-template
  let-fieldItemData="fieldItemData"
  let-content="content"
  let-index="index"
  #fieldItemDataValues>
  <ng-container
    *ngIf="
      fieldItemData?.fieldValue &&
      fieldItemData?.fieldType !== 'customfileupload' &&
      fieldItemData?.fieldType !== 'externalfileupload' &&
      fieldItemData?.fieldType !== 'custominternalfileupload'
    ">
    <ng-container
      *ngIf="multiLineValueFieldTypes.includes(fieldItemData.fieldType)">
      <div
        *ngFor="let value of getMultiLineValues(fieldItemData)"
        class="fieldValue">
        <p class="group-text dark-grey-color tt_norms400 m-0">
          {{ value?.label ?? '' | translate }}:
        </p>
        <p class="group-value tt_norms500 m-0">
          {{ value.key ?? '' | translate }}
        </p>
      </div>
    </ng-container>

    <div
      *ngIf="!multiLineValueFieldTypes.includes(fieldItemData.fieldType)"
      class="fieldValue">
      <p class="group-text dark-grey-color tt_norms400 m-0">
        {{ fieldItemData?.fieldLabel ?? '' | translate }}:
      </p>
      <p class="group-value tt_norms500 m-0">
        <ng-container
          *ngIf="!complexFieldTypes.includes(fieldItemData.fieldType)">
          {{ getSingleLineValue(fieldItemData) ?? '' }}
        </ng-container>
        <ng-container
          *ngIf="complexFieldTypes.includes(fieldItemData.fieldType)">
          <!-- Multi-Select Data Fetch with Dynamic Metadata -->
          <ng-container
            *ngIf="fieldItemData.fieldType === 'custommultiselectdatafetch'">
            <!-- Dynamic Summary Section -->
            <div
              class="row mb-3"
              *ngIf="
                fieldItemData?.additionalData?.previewMetadataConfig?.length > 0
              ">
              <ng-container
                *ngFor="
                  let config of fieldItemData?.additionalData
                    ?.previewMetadataConfig
                ">
                <div class="col-md-6 mb-2">
                  <p class="group-text dark-grey-color tt_norms400 m-0">
                    {{ config.label | translate }}
                  </p>
                  <p class="group-value tt_norms500 m-0">
                    {{ config.prefix | translate }}
                    {{ config.formatter === 'number' || config.formatter === 'currency' ? (fieldItemData?.additionalData?.metadata?.[config.key] | number) : fieldItemData?.additionalData?.metadata?.[config.key]}}
                    {{ config.suffix | translate }}
                  </p>
                </div>
              </ng-container>
            </div>

            <!-- Data Table -->
            <div class="mt-3">
              <irembogov-data-table
                [columns]="fieldItemData?.additionalData?.columns"
                [searchable]="false"
                [selectable]="false"
                [data]="fieldItemData?.fieldValue"
                [minimalPagination]="true">
              </irembogov-data-table>
            </div>
          </ng-container>

          <!-- Regular Data Tables -->
          <irembogov-data-table
            *ngIf="fieldItemData.fieldType === 'customdatatable'"
            [columns]="fieldItemData?.additionalData"
            [searchable]="false"
            [selectable]="false"
            [data]="fieldItemData?.fieldValue"
            [minimalPagination]="true">
          </irembogov-data-table>

          <!-- Table with input block -->
          <irembogov-table-with-input-preview
            *ngIf="fieldItemData.fieldType === 'customtablewithinputform'"
            [columns]="fieldItemData?.additionalData"
            [data]="fieldItemData?.fieldValue">
          </irembogov-table-with-input-preview>

          <irembogov-editable-table
            *ngIf="fieldItemData.fieldType === 'customeditabletable'"
            [rows]="fieldItemData?.additionalData?.rows"
            [columns]="fieldItemData?.additionalData?.columns"
            [showRowLabels]="
              fieldItemData?.additionalData?.showRowLabels ?? true
            "
            [rowColumnTitle]="
              fieldItemData?.additionalData?.rowColumnTitle || ''
            "
            [tableData]="fieldItemData?.fieldValue"
            [readOnly]="true">
          </irembogov-editable-table>
        </ng-container>
      </p>
    </div>
  </ng-container>

  <!-- Custom File Upload -->
  <ng-container
    *ngIf="
      fieldItemData?.fieldType === 'customfileupload' ||
      fieldItemData?.fieldType === 'custominternalfileupload'
    ">
    <div class="d-flex">
      <div
        class="flex-shrink-0"
        (click)="previewAttachment(content, fieldItemData.fieldValue, index)">
        <img
          src="../../assets/images/file-icon.svg"
          class="file-preview-icon"
          alt="preview" />
      </div>
      <div class="flex-grow-1 ms-3">
        <p class="group-value dark-grey-color tt_norms400 mb-1">
          {{ fieldItemData?.fieldLabel ?? '' | translate }}:
        </p>
        <p class="group-text dark-grey-color tt_norms500 m-0">
          {{
            getAttachmentValue(fieldItemData?.fieldValue).fileSize | fileSize
          }}
        </p>
      </div>
    </div>
  </ng-container>

  <!-- External File Upload -->
  <ng-container *ngIf="fieldItemData?.fieldType === 'externalfileupload'">
    <div class="d-flex">
      <div
        class="flex-shrink-0"
        [style.cursor]="
          getExternalAttachmentDetails(fieldItemData?.fieldValue).url
            ? 'pointer'
            : 'default'
        "
        (click)="openExternalFileUrl(fieldItemData?.fieldValue)">
        <img
          src="../../assets/images/file-icon.svg"
          class="file-preview-icon"
          alt="external file" />
      </div>
      <div class="flex-grow-1 ms-3">
        <p
          class="group-text dark-grey-color tt_norms400 mb-1"
          style="font-size: 0.875rem">
          {{ fieldItemData?.fieldLabel ?? '' | translate }}:
        </p>
        <h6
          class="group-value text-dark fw-bold mb-2 tt_norms500"
          style="
            word-break: break-word;
            white-space: normal;
            overflow-wrap: anywhere;
            line-height: 1.4;
            max-width: 100%;
            font-size: 1rem;
          ">
          {{
            getExternalAttachmentDetails(fieldItemData?.fieldValue).fileName ||
              getExternalAttachmentFileName(fieldItemData?.fieldValue)
          }}
        </h6>
        <p
          class="group-text dark-grey-color tt_norms400 m-0"
          style="font-size: 0.875rem">
          {{ getExternalAttachmentDetails(fieldItemData?.fieldValue).fileSize }}
          •
          {{ getExternalAttachmentDetails(fieldItemData?.fieldValue).fileType }}
        </p>
        <p
          *ngIf="getExternalAttachmentDetails(fieldItemData?.fieldValue).url"
          class="group-text text-primary tt_norms400 mt-1 mb-0"
          style="font-size: 0.75rem; word-break: break-all">
          {{ 'URL' | translate }}:
          {{ getExternalAttachmentDetails(fieldItemData?.fieldValue).url }}
        </p>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- Nested Block Template -->
<ng-template let-fieldGroupNameData="fieldGroupNameData" #nestedBlock>
  <div class="my-3">
    <irembogov-application-form-field-card
      [group]="fieldGroupNameData"
      [applicationId]="applicationId"
      [baseUrl]="baseUrl"
      [applicationPath]="applicationPath">
    </irembogov-application-form-field-card>
  </div>
</ng-template>
